export default "__VITE_ASSET__2bd3cfd1__"